import { useMemo, useState } from "react";
import moment from "moment";
import {
  useExportVerticalsUsageReport,
  useVericalsUsageReportQuery,
} from "./query/useVerticalsUsageReportQuery";
import { API_DATE_FORMAT, ORDER_TYPES } from "../../../../../../consts/api";
import { useClinicsQuery } from "../../../../../../api/queries/useClinicsQuery";
import { composeDownloadDataUrl } from "../../../../../../utilities/api";
import { uiNotification } from "../../../../../../services/UINotificationService";

export const useReport = () => {
  const [period, setPeriod] = useState({
    from: moment().startOf("month").toDate(),
    to: new Date(),
  });

  const [order, setOrder] = useState({
    by: null,
    direction: null,
  });

  const [clinicId, setClinicId] = useState(null);

  const updateOrder = (orderFieldKey) => {
    setOrder({
      by: orderFieldKey,
      direction:
        order.direction === ORDER_TYPES.desc
          ? ORDER_TYPES.asc
          : ORDER_TYPES.desc,
    });
  };

  const { data, isLoading } = useVericalsUsageReportQuery({
    sortBy: order.by,
    order: order.direction,
    start_date: moment(period.from).format(API_DATE_FORMAT),
    end_date: moment(period.to).format(API_DATE_FORMAT),
    clinic_ids: clinicId ? [clinicId] : undefined,
  });

  const { mutate: downloadExcel, isLoading: isDownloading } =
    useExportVerticalsUsageReport();

  const { data: clinics, isLoading: isClinicsLoading } = useClinicsQuery();

  const handleDownload = () => {
    downloadExcel(
      {
        sortBy: order.by,
        order: order.direction,
        start_date: moment(period.from).format(API_DATE_FORMAT),
        end_date: moment(period.to).format(API_DATE_FORMAT),
        clinic_ids: clinicId ? [clinicId] : undefined,
      },
      {
        onSuccess: (res) =>
          window.open(composeDownloadDataUrl(res.data.data.file), "_blank"),
        onError: (err) =>
          uiNotification.error(
            err?.res?.data?.message || "Error downloading report",
          ),
      },
    );
  };

  const allClinics = useMemo(() => {
    const clinicsOptions = clinics?.map((clinic) => ({
      value: clinic.id,
      label: clinic.name,
    }));
    return clinicsOptions || [];
  }, [clinics]);

  return {
    data,
    isLoading: isLoading || isClinicsLoading,
    period: {
      value: period,
      update: setPeriod,
    },
    order: {
      value: order,
      update: updateOrder,
    },
    clinic: {
      value: clinicId,
      onChange: setClinicId,
      options: allClinics,
    },
    download: {
      initiate: handleDownload,
      isLoading: isDownloading,
    },
  };
};
